module.exports = __webpack_public_path__ + "static/media/1.c94d539b.jpg";